export default function (element) {
	if (!element) {
		return;
	}
	const scriptId = element.dataset.scriptId;

	if (!scriptId) {
		return;
	}

	function init() {
		let d = document, c = {}, f = d.createElement("div"), h = !1, a = window.usabilla = function() { (c.a = c.a || []).push(arguments) };
		a._ = c;
		c.ids = {};
		f.style.display = "none";
		(function setup() {
			if (!d.body) return setTimeout(setup, 100);
			d.body.insertBefore(f, d.body.firstChild).id = "usabilla";
			h = !0
		})();
		a.load = function(a, g, k) {
			if (!c.ids[g]) {
				let e = c.ids = {};
				e.url = "//" + a + "/" + g + ".js?s1";
				e.config = k;
				setTimeout(function buildFrame() {
					if (!h) return setTimeout(buildFrame, 100);
					let b = d.createElement("iframe"), a;
					b.id = "usabilla-" + g;
					f.appendChild(b);
					try {
						b.contentWindow.document.open()
					} catch (c) {
						e.domain = location.hostname; 
						a = "javascript:let d=document.open();d.domain='" + e.domain + "';";
						b.src = a + "void(0);"
					}
					try {
						let l = b.contentWindow.document;
						l.write(["<!DOCTYPE html><html><head></head><body onload=\"let d = document;d.getElementsByTagName('head')[0].appendChild(d.createElement('script')).src='", e.url, "'\"></body></html>"].join(""));
						l.close()
					} catch (m) {
						b.src = a + 'd.write("' + loaderHtml().replace(/"/g, String.fromCharCode(92) + '"') + '");d.close();'
					}
					b.contentWindow.config = k;
					b.contentWindow.SCRIPT_ID = g
				}, 0);
			}
		}
	};

	window.usabilla || init();

	window.usabilla.load("w.usabilla.com", scriptId);
}